import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState() {
  return {};
}

const state = initialState();

// actions

const actions = {
  async get(context, payload) {
    var response = await API.filmMaker.get(payload);
    return response.film_maker;
  },
};

// getters
const getters = {};

// mutations
const mutations = {
  reset(state) {
    state.list = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
